import { render, staticRenderFns } from "./BlockEditorHeading3.vue?vue&type=template&id=632d7a1c&"
import script from "./BlockEditorHeading3.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorHeading3.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports